import { FlagProvider } from '@unleash/proxy-client-react';

const BASE_CONFIG = {
  url: process.env.REACT_APP_UNLEASH_URL || '',
  clientKey: process.env.REACT_APP_UNLEASH_KEY || '',
  disableRefresh: true,
  appName: 'rize-farm',
};

const UnleashProvider = ({ children, config = {} }) => {
  const UNLEASH_CONFIG = { ...BASE_CONFIG, ...config };
  return <FlagProvider config={UNLEASH_CONFIG}>{children}</FlagProvider>;
};

export default UnleashProvider;
